// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"83be082f","269":"8d1f9302","296":"b40ab975","447":"e2a5a13c","523":"94968560","668":"2df9fea5","967":"f3f6aad6"}[chunkId] + ".chunk.js";
};